import { useEffect, useRef, useState } from 'react';
import { GetProductState } from '../../../core/initialState';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { ITeplarVM } from '../../../models/response/ITeplarResponse';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import StepOne from './step-one';
import StepTwo from './step-two';
import StepFour from './step-four';
import StepThree from './step-three';

interface IProps extends IAddEditFormProps<any> {
  // teplarDetailsList: ITeplarVM[];
  validateProductName: (productId: string) => void;
  isProductNameValid: boolean;
  onSaveAndNextClick: () => void;
  setCloseModal: (isClose: boolean) => void;
}

const AddEditProductManagementForm = (props: IProps) => {
  const [data, setData] = useState({ ...props.initialValues });
  const [currentStep, setCurrentStep] = useState<number>(0);
  const stepTransitionLockRef = useRef<boolean>(false);

  useEffect(() => {
    setData({ ...props.initialValues });
  }, [props.initialValues]);

  useEffect(() => {
    stepTransitionLockRef.current = false;
  }, [currentStep]);

  const handleNextStep = (newData: any, final: boolean = false) => {
    if (stepTransitionLockRef.current) {
      return;
    }
    stepTransitionLockRef.current = true;

    // console.log('Product Payload:', { ...data, ...newData });
    setData((prev) => ({ ...prev, ...newData }));
    if (final) {
      props.submitHandler({ ...newData });
      stepTransitionLockRef.current = false;
      return;
    }
    setCurrentStep((prev) => Math.min(prev + 1, 3));
  };

  const handleSaveAndNext = (newData: any, isCreateNew: boolean = false) => {
    // console.log('Product Payload (Save and Next):', { ...data, ...newData });
    setData({
      Id: -1,
      ...GetProductState,
    });
    if (isCreateNew) {
      props.submitHandler({ ...newData });
      props.onSaveAndNextClick();
      return;
    }
  };

  const handlePrevStep = (newData: any) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };

  const steps = [
    <StepOne
      next={handleNextStep}
      data={data}
      isLoading={props.isLoading}
      onModalClosed={props.onModalClosed}
      id={props.id}
      validateProductName={props.validateProductName}
      isProductNameValid={props.isProductNameValid}
    />,
    <StepThree // It is step 2 on UI Form
      next={handleNextStep}
      handleSaveAndNext={handleSaveAndNext}
      prev={handlePrevStep}
      initalValues={data}
      id={props.id}
      isLoading={props.isLoading}
      // teplarDetailsList={
      //   props.id < 0
      //     ? props.teplarDetailsList
      //     : props.initialValues.ProductTeplars
      // }
      // teplarDetailsList={data.ProductTeplars}
      setCurrentStep={setCurrentStep}
      setCloseModal={props.setCloseModal}
    />,
    <StepTwo  // It is step 3 on UI Form
      id={props.id}
      next={handleNextStep}
      prev={handlePrevStep}
      initalValues={data}
      isLoading={props.isLoading}
      processList={props.initialValues.Process}
      handleSaveAndNext={handleSaveAndNext}
      setCloseModal={props.setCloseModal}
      setCurrentStep={setCurrentStep}
    />,
    <StepFour
      next={handleNextStep}
      handleSaveAndNext={handleSaveAndNext}
      prev={handlePrevStep}
      data={data}
      id={props.id}
      isLoading={props.isLoading}
      onModalClosed={props.onModalClosed}
      // teplarDetailsList={
      //   props.id < 0
      //     ? props.teplarDetailsList
      //     : props.initialValues.ProductTeplars
      // }
      // teplarDetailsList={data.ProductTeplars}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      setCloseModal={props.setCloseModal}
    />,
  ];

  return (
    <div>
      {props.isLoading && <FormLoader loading={props.isLoading} contained />}
      {steps[currentStep]}
    </div>
  );
};

export default AddEditProductManagementForm;
